import { List, ListProps } from '@mui/material'
import React, { FC } from 'react';

const ListWrapper: FC<ListProps> = ({...props}) => <List {...props}/>

export default ListWrapper;